import React from 'react'

import { type StepWizardChildProps } from 'react-step-wizard'
import styled from 'styled-components'

import { IconCheckmark } from 'assets/svg/sprite'
import colors from 'styles/colors'

export function VerificationNavbar({
    currentStep,
    totalSteps
}: Partial<StepWizardChildProps>) {
    return (
        <StepsContainer>
            {[...Array(totalSteps)].map((step, i) => (
                <React.Fragment key={i}>
                    <Step
                        $isActive={currentStep === i + 1}
                        $isDone={currentStep ? currentStep > i + 1 : false}
                    >
                        {(currentStep ? currentStep > i + 1 : false) ? (
                            <IconCheckmark />
                        ) : (
                            `${i + 1}`
                        )}
                    </Step>
                    {totalSteps !== i + 1 && <Line />}
                </React.Fragment>
            ))}
        </StepsContainer>
    )
}

const StepsContainer = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
    padding-bottom:1rem;
    margin-bottom: 1rem;
`
interface StepProps {
    $isActive: boolean
    $isDone?: boolean
}
const Step = styled.div<StepProps>`
    width: 3rem;
    height: 3rem;
    border-radius: 3rem;
    background: ${props =>
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        props.$isDone || props.$isActive
            ? colors.blue92deg
            : colors.slateBlueGray};
    display: flex;
    justify-content: center;
    align-items: center;

    color: ${colors.white};
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.4rem;
    line-height: 1.7rem;

    position: relative;

    ${props =>
        props.$isActive
            ? ` &::before {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        border: 1px solid ${colors.blueLighter};
        border-radius: 100%;
    }`
            : ''}
`

const Line = styled.span`
    height: 0.2rem;
    width: 2rem;
    background: #e3e9f2;
    border-radius: 0.5rem;
    margin: 0 1rem;
`
